(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('PortDialogController', PortDialogController);

    PortDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Port'];

    function PortDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Port) {
        var vm = this;

        vm.port = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.port.id !== null) {
                Port.update(vm.port, onSaveSuccess, onSaveError);
            } else {
                Port.save(vm.port, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:portUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
